import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import {
  Box,
  PageWithNavigation,
  Title,
  Input,
  Button,
} from '../../components';
import transactionList from './transactionsList';
import './index.css';
import SelectComponent from '../../components/SelectComponent';

const { api, dateFormat } = require('@cashew/utils');

const ns = 'transactions-management';

export default () => {
  const [storeId, setStoreId] = useState('');
  const [merchantId, setMerchantId] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [installmentId, setInstallmentId] = useState('');
  const [installmentList, setInstallmentList] = useState([
    { key: '', value: 'No installment' },
  ]);
  const [settlementId, setSettlementId] = useState('');
  const [settlementList, setSettlementList] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [amounts, setAmounts] = useState([
    { key: '0.79', value: '0.79' },
    { key: '1', value: '1' },
  ]);
  const [orderJson, setOrderJson] = useState<any>({});
  const [productJson, setProductJson] = useState<any>({});
  const [settlementJson, setSettlementJson] = useState<any>({});
  const [currencyCode, setCurrencyCode] = useState('AED');
  const [transactionType, setTransactionType] = useState('');
  const [transactionStatus, setTransactionStatus] = useState('PENDING');
  const [createdAt, setCreatedAt] = useState('');
  const { orderId }: any = useParams();

  useEffect(() => {
    api
      .get({
        endpoint: `orders/${orderId}`,
      })
      .then((resp: any) => {
        setMerchantId(resp.data.merchantId);
        setStoreId(resp.data.storeId);
        setCustomerId(resp.data.cashewCustomerId);
        setCurrencyCode(resp.data.currencyCode);
        setOrderJson(resp.data);

        api
          .get({
            endpoint: 'settlements',
            params: {
              size: 1000,
            },
          })
          .then((settlementResp: any) => {
            let settlements = [{ key: '', value: 'No settlement' }];
            settlements = [
              ...settlements,
              ...settlementResp.data
                .filter(
                  (item: any) =>
                    item.merchantId === resp.data.merchantId ||
                    item.settlementType === 'BANK_CASHEW' ||
                    item.settlementType === 'PAYFORT_CASHEW'
                )
                .map((item: any) => ({
                  key: item.settlementId,
                  value: `${item.settlementId} - (${dateFormat({ date: item.cycleStartDate, withTime: true })} to ${dateFormat({ date: item.cycleEndDate, withTime: true })}) - ${item.settlementType}`,
                })),
            ];
            setSettlementList(settlements);
            setSettlementJson(settlementResp.data);
          })
          .catch(() => console.log('Error fetching settlements'));
        api
          .get({
            endpoint: `products/options/${orderId}`,
          })
          .then((productResp: any) => {
            let list = [
              ...amounts,
              { key: resp.data.totalAmount, value: resp.data.totalAmount },
            ];
            if (productResp.data.type === 'DIVIDE') {
              const installment = Math.ceil(resp.data.totalAmount / 3);
              list = [...list, { key: installment, value: installment }];
            }
            setInstallmentList([
              ...installmentList,
              ...productResp.data.subProducts[0].installments.map(
                ({ id }: any) => ({ key: id, value: id })
              ),
            ]);
            setAmounts(list);
            setProductJson(productResp.data);
          })
          .catch(() => console.log('Error fetching product'));
      })
      .catch(() => console.log('Error fetching order'));
  }, []);

  return (
    <div className={ns}>
      <Helmet>
        <title>Manage transaction</title>
      </Helmet>
      <PageWithNavigation>
        <Title>Manage transaction</Title>
        <Box>
          <SelectComponent
            data={transactionList}
            label="Transaction type"
            selected={transactionType}
            onSelect={(e: string) => {
              switch (e) {
                case 'ORDER_CASHEW_FEE':
                  setTotalAmount('1');
                  break;
                case 'PAYMENT_GATEWAY_TRANSACTION_FEE':
                  setTotalAmount('0.79');
                  break;
                case 'CUSTOMER_INSTALLMENT_PAYMENT':
                case 'CUSTOMER_ORDER_PAYMENT':
                  setTotalAmount(amounts[amounts.length - 1].key);
                  break;
                default:
                  setTotalAmount('');
              }
              setTransactionType(e);
            }}
          />
          <Input
            placeholder="merchant Id"
            name="merchantId"
            readonly
            value={merchantId}
            onChange={(e) => setMerchantId(e.target.value)}
          />
          <Input
            placeholder="store Id"
            name="storeId"
            readonly
            value={storeId}
            onChange={(e) => setStoreId(e.target.value)}
          />
          <Input
            placeholder="customer Id"
            name="customerId"
            readonly
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
          />
          <SelectComponent
            data={installmentList}
            label="Installment id"
            selected={installmentId}
            onSelect={(e: string) => setInstallmentId(e)}
          />
          <SelectComponent
            data={settlementList}
            label="Settlement Id"
            selected={settlementId}
            onSelect={(e: string) => setSettlementId(e)}
          />
          <SelectComponent
            data={amounts}
            label="total Amount"
            selected={totalAmount}
            onSelect={(e: string) => setTotalAmount(e)}
          />
          <Input
            placeholder="Currency code"
            name="customerId"
            readonly
            value={currencyCode}
          />
          <SelectComponent
            data={[
              {
                key: 'PENDING',
                value: 'PENDING',
              },
              {
                key: 'PROCESSED',
                value: 'PROCESSED',
              },
            ]}
            label="Transaction status"
            selected={transactionStatus}
            onSelect={(e: string) => setTransactionStatus(e)}
          />
          <Input
            placeholder="Date"
            name="createdAt"
            value={createdAt}
            onChange={(e) => setCreatedAt(e.target.value)}
          />
          <Button
            onClick={() => {
              api.post({
                endpoint: 'transactions',
                params: {
                  orderId,
                  merchantId,
                  storeId,
                  customerId,
                  installmentId: installmentId || null,
                  settlementId: settlementId || null,
                  totalAmount,
                  currencyCode,
                  transactionType,
                  transactionStatus,
                  createdAt,
                },
              });
            }}
          >
            Created
          </Button>
          <p>Order data</p>
          <pre>{JSON.stringify(orderJson, null, 2)}</pre>
          <p>Product data</p>
          <pre>{JSON.stringify(productJson, null, 2)}</pre>
          <p>Settlement data</p>
          <pre>{JSON.stringify(settlementJson, null, 2)}</pre>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
